module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap13"
    }
  }, [_vm._v("THIRTEEN")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE OPENED HER")]), _vm._v(" own door and went in. All the way back she had met no one, heard nothing. Her anger was so hot in her that she did not miss the coat, lying where she had dropped it in the study at Melling House. She did not remember it or think of it at all. She thought about Carr, she thought about Catherine, she thought about her own quick anger and was aghast.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She opened the door of the living-room and went in. Fancy looked up, yawning.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You’ve missed the nine o’clock news.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Instinctively Rietta glanced at the clock, an old round wall-clock hanging on the chimney breast. It was twenty past nine. A dance band was swinging the latest song hit. She put out her hand and switched it off.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Has Carr come back?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Fancy yawned again. She really had lovely teeth, as white as milk and as even as peas in a pod.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No, he hasn’t. What’s the matter with him, Miss Cray?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Rietta came and stood over her, tall and frowning.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I want you to tell me what happened—when I was out of the room.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The large blue eyes blinked up at her. There was an obvious attempt to control another yawn. Rietta thought with exasperation that the creature looked exactly like a sleepy child. You couldn’t blame her for it, but it wasn’t a situation in which a child was going to be much use. She said,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I want you to tell me just what happened whilst I was at the telephone.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Well—’ The eyes remained wide and a little unfocussed. ‘I don’t know that anything happened—much. Not till the end.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘What happened then?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Well, we were looking at those papers—the ones Mr. Ainger brought—and I’d seen a hat I liked, and I was thinking about how I could copy it, so I wasn’t taking a lot of notice—you don’t when you’re thinking about something special. And all at once there was Carr, calling out. I thought he must have been stung or something. He looked awful, Miss Cray, he really did. And he said, “The damned swine!” and I said, “Where?” because I didn’t know what he meant—I don’t see how I could. And then you came in, and he said that piece about its being the man who took Marjory away—in the picture he was looking at—and he asked you if it was James Lessiter. Marjory was his wife, wasn’t she? I mean, she was Carr’s wife, and that James Lessiter went off with her. Carr won’t do any thing silly, will he?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Rietta said, ‘No,’ in a deep, determined voice. It seemed to surprise Fancy a little. She blinked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Well, you can’t pick up spilt milk again, can you?’ Rietta said, ‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Fancy yawned.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘By what I’ve heard she wasn’t much loss, was she?’ Then she blinked again. ‘Perhaps I oughtn’t to have said that. You weren’t fond of her, were you?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No, I wasn’t fond of her.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘By all accounts nobody was. I expect Carr got a bit of a jolt with her. He’s kind of—nice, isn’t he? When I told Mum about him she said she reckoned he’d had his feelings pretty badly hurt. She told me to look out and be careful. “Have him if you want to, Ducks, or don’t have him if you don’t want to, but don’t play him up.” That’s what Mum said.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘And which are you going to do?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At any other time there might have been sarcasm in the question. At this moment Rietta put it with complete simplicity, and with equal simplicity Fancy answered her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘He doesn’t want me. He said we wouldn’t fit in. I think he likes that girl where he took me to tea—that Elizabeth Moore. He was fond of her, wasn’t he?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘A long time ago.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Why didn’t he marry her?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘He met Marjory.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Fancy nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘She was the sort who’d snatch. I only really met her once, but you could see how she was. Oh, Miss Cray, whatever have you done to your hand? It’s all over blood!’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Rietta glanced down at her right hand. It was astonishing how much blood had come from that small scratch. Up at Melling House she had wrapped James Lessiter’s handkerchief about it. It must have dropped whilst they were talking, and the bleeding had started again. It was dry now, but what a mess. She went down the passage to the lavatory and held it under the cold tap until the stain was gone.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6da734d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/16-chap13.vue
// module id = 117
// module chunks = 0